function format(amount, decimalSeparator = ',', fixed: boolean = true): string {
    const value = Number(amount);

    if (Number.isNaN(value) || amount === null) {
        return '';
    }

    const startingPosition = value > 0 ? 0 : 1;
    const fixedValue = fixed ? value.toFixed(2) : value;

    if (decimalSeparator === ',') {
        return String(fixedValue).replace(/./g, (c, i, a) => {
            if (c === '.') {
                return ',';
            } else if (i > startingPosition && c !== '.' && (a.length - i) % 3 === 0) {
                return `.${c}`;
            }

            return c;
        });
    }

    return String(fixedValue).replace(/./g, (c, i, a) => {
        return i > startingPosition && c !== '.' && (a.length - i) % 3 === 0 ? `,${c}` : c;
    });
}

function parse(amount = '', decimalSeparator = ','): number | undefined {
    if (typeof amount === 'number') {
        return amount;
    }

    if (amount === null || !amount.length) {
        return undefined;
    }

    let value;

    if (decimalSeparator === ',') {
        // replace digit seperator then replace decimal separator
        value = Number(amount.replace(/\./g, '').replace(',', '.'));
    } else {
        // replace digit seperator
        value = Number(amount.replace(/,/g, ''));
    }

    return Number.isNaN(value) ? undefined : value;
}

function parseExpression(textValue, decimalSeparator): string {
    try {
        if (typeof textValue === 'number') {
            const valueNumberFormatted = format(textValue, decimalSeparator);
            return valueNumberFormatted;
        }

        let textValueString = String(textValue);
        if (textValueString.trim() === '') {
            return format(textValue, decimalSeparator);
        }

        let parsedExprToNr = parse(textValueString, decimalSeparator);
        if (parsedExprToNr !== undefined) {
            let formatedValid = format(parsedExprToNr, decimalSeparator);
            return formatedValid;
        }

        if (textValue === undefined || !textValueString.trim().startsWith('=', 0)) {
            //Expression that is not number should start with "=" as in Daybook
            let parsedInvalidExpression = format(undefined, decimalSeparator);
            return parsedInvalidExpression;
        }

        let expressionStr = textValueString;
        if (textValueString.trim().startsWith('=', 0)) {
            expressionStr = textValueString.trim().substring(1);
        }

        let regExpContent = '^[^a-zA-Z$%&@!~#?`^]*[+-/*]*([(]*)*([0-9.]?([0-9,]?)([)]*))+$';

        let regExpExpression = new RegExp(regExpContent);
        let matchesRegExp = regExpExpression.test(expressionStr.replace(/\s/g, ''));

        if (!matchesRegExp) {
            let parsedUnmatchedRegExp = format(undefined, decimalSeparator);
            return parsedUnmatchedRegExp;
        }

        let expressionMatchArray =
            expressionStr.replace(/\s/g, '').match(/([$%&@!~#?`]+)*([(])*[+-/*]*([(]+?)*([0-9.]?([0-9,]?[0-9.]+?)+=*([)])?)/g) ||
            [];

        let clonedExpressionTerms = JSON.parse(JSON.stringify(expressionMatchArray));

        clonedExpressionTerms.forEach((element, index) => {
            let numberOnly = element.match(/([0-9,]*[0-9.]+)*([0-9.]*[0-9,]+)/g) || [];
            if (numberOnly !== undefined && numberOnly !== '') {
                let numberParsed = parse(numberOnly.toString(), decimalSeparator);
                if (numberParsed !== undefined) {
                    clonedExpressionTerms[index] = element.replace(numberOnly.toString(), numberParsed.toString());
                }
            }
        });

        let expressionJoined = clonedExpressionTerms.join('');
        if (expressionJoined.includes(',')) {
            let parsedDefaultExpr = format(undefined, decimalSeparator);
            return parsedDefaultExpr;
        }

        // eslint-disable-next-line
        let resultEval = Function(`'use strict'; return (${expressionJoined})`)();
        let parsedNumberFormat = format(resultEval, decimalSeparator);
        return parsedNumberFormat;
    } catch (error) {
        let parsedDefault = format(undefined, decimalSeparator);
        return parsedDefault;
    }
}

export default {
    format,
    parse,
    parseExpression,
};
